import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, isAdmin } = useAuth();

  if (isAuthenticated) {
    if (isAdmin()) {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/my-account/manage-listing" replace />;
  }

  return children;
};

export default PublicRoute;
